import { Pencil, Send, Check, X, Lock, ArrowRight, Info } from 'lucide-react';

/**
 * KanbanLegend
 *
 * Leyenda explicativa del flujo de estados sobre el kanban.
 * Cada estado tiene su pill + sub-texto propio (no se agrupan,
 * para que quede claro que TANTO aprobada COMO rechazada estan
 * bloqueadas).
 *
 *   FLUJO DE ESTADOS
 *   [Borrador]  ->  [Enviada]  ->  [Aprobada]  /  [Rechazada]
 *   Editable y      Se puede        Bloqueada       Bloqueada
 *   movible         mover
 *
 *   i  Aprobada y rechazada quedan bloqueadas porque la cotizacion
 *      ya esta en curso o cerrada y no puede cambiar de estado.
 *
 * Props:
 *   - puedeDesbloquear: boolean — true si el usuario puede mover finales
 */
const KanbanLegend = ({ puedeDesbloquear = false }) => {
    return (
        <section className="kanban-legend" aria-label="Flujo de estados de cotizaciones">
            <div className="kanban-legend-title">Flujo de estados</div>

            <div className="kanban-legend-flow">
                <div className="kanban-legend-step kanban-legend-step--borrador">
                    <span className="kanban-legend-pill">
                        <Pencil size={12} aria-hidden="true" />
                        Borrador
                    </span>
                    <span className="kanban-legend-sub">Editable y movible</span>
                </div>

                <ArrowRight size={16} className="kanban-legend-arrow" aria-hidden="true" />

                <div className="kanban-legend-step kanban-legend-step--enviada">
                    <span className="kanban-legend-pill">
                        <Send size={12} aria-hidden="true" />
                        Enviada
                    </span>
                    <span className="kanban-legend-sub">Se puede mover</span>
                </div>

                <ArrowRight size={16} className="kanban-legend-arrow" aria-hidden="true" />

                <div className="kanban-legend-step kanban-legend-step--aprobada">
                    <span className="kanban-legend-pill">
                        <Check size={12} aria-hidden="true" />
                        Aprobada
                    </span>
                    <span className="kanban-legend-sub kanban-legend-sub--lock">
                        <Lock size={11} aria-hidden="true" /> Bloqueada
                    </span>
                </div>

                <span className="kanban-legend-slash" aria-hidden="true">/</span>

                <div className="kanban-legend-step kanban-legend-step--rechazada">
                    <span className="kanban-legend-pill">
                        <X size={12} aria-hidden="true" />
                        Rechazada
                    </span>
                    <span className="kanban-legend-sub kanban-legend-sub--lock">
                        <Lock size={11} aria-hidden="true" /> Bloqueada
                    </span>
                </div>
            </div>

            <div className="kanban-legend-note">
                <Info size={13} aria-hidden="true" />
                <span>
                    Aprobada y rechazada quedan bloqueadas porque la cotización
                    ya está en curso o cerrada y no puede volver a cambiar de estado.
                    {puedeDesbloquear && (
                        <strong className="kanban-legend-note-perm">
                            {' '}Tu rol puede desbloquearlas.
                        </strong>
                    )}
                </span>
            </div>
        </section>
    );
};

export default KanbanLegend;
